import React from "react";
import PropTypes from "prop-types";
import SimpleTextDialog from "components/SimpleTextDialog";

const PreviewFileDialog = props => (
  <SimpleTextDialog
    showDialog={props.previewFileDialogOpen}
    title={props.previewFileTitle}
    body={props.previewFileBody}
    closeDialog={props.onCloseViewFileDialog}
    enableScroll
  />
);

PreviewFileDialog.propTypes = {
  previewFileDialogOpen: PropTypes.bool.isRequired,
  previewFileTitle: PropTypes.string,
  previewFileBody: PropTypes.string,
  onCloseViewFileDialog: PropTypes.func.isRequired
};

PreviewFileDialog.defaultProps = {
  previewFileTitle: "",
  previewFileBody: ""
};

export default PreviewFileDialog;
